import React, { useState, useEffect, useRef } from 'react';
import { getUserById, editUserPrivileges } from '../../flux/actions/userActions';
import { Container, Row, Col, Button, Input, Label, FormGroup } from 'reactstrap';

import { connect } from 'react-redux';
import { UserCardContainer, IUserCardReduxProps } from '../../types/interfaces';
import UserEdit from '../user/UserEdit';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faCommentAlt, faCrown, faExclamationCircle, faExternalLinkAlt, faHashtag, faPen, faPhone, faQuestionCircle, faSave, faSignature, faSpinner, faUser } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { PRIVILEGE } from '../../types/privileges'
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';
import ReactTooltip from 'react-tooltip';
import { constants } from '../../types/constants';

const UserCardContainerComponent = ({ 
  getUserById,
  editUserPrivileges,
  user
 }: UserCardContainer) => {
  const history = useHistory();
  const alert = useAlert();
  const { info, loading } = user;
  const [copiedFlag, setCopiedFlag] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [editModal, setEditModal] = useState(false);
  
  let { id } = useParams();

  useEffect(() => {
    if(id !== undefined && id !== null && !isNaN(id) && id >= 0)
      getUserById(id);
  }, []);

  const handleToggleEdit = () => setEditModal(!editModal);


  const savePrivileges = () => {
    // editUserPrivileges(id, Object.entries(privileges).filter(e => !!e[1]).map(e => PRIVILEGE[e[0]]), callback)
  }

  return loading ? <LoadingPage/> : (
    <>
      {/* <Container><h2 className="title">Gestion Utilisateur</h2></Container> */}
      <Container>
        <Row className="justify-content-between">
          <Col xs="12" sm="8"><h2 className="title">Gestion TKN</h2></Col>
          <Col xs="12" sm="4" className="modalAddBtnCol">
            {/* <Button
              className="btn btn-success linesConfirmationBtn"
              onClick={() => setEditModal(true)}
              ><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modifier</Button> */}
          </Col>
        </Row>
      </Container>
      {info ? (
      <Container className="CardInfo">
        <Row>
          <Col xs="12" style={{color: "red"}}>
            <FontAwesomeIcon icon={faExclamationCircle} />&nbsp;<strong>EN CONSTRUCTION.</strong>
          </Col>
        </Row>
      </Container>
      ) : `ID ${id} non valide.`}

      {/* <UserEdit modal={editModal} setModal={setEditModal} handleToggle={handleToggleEdit} modalUser={info} /> */}
    </>
  );
};

const mapStateToProps = (state: IUserCardReduxProps) => ({
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, { getUserById, editUserPrivileges })(UserCardContainerComponent);
